if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact');
			this.priceExtended = this.querySelector('[data-js-product-price-extended');

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
			}

			// quantity shortcut buttons + subtotal

			this.qtyInput = this.querySelector('.qty-selector');
			this.quantityShortcuts = this.querySelector('[data-js-quantity-shortcuts]');
			this.subtotal = this.querySelector('[data-js-product-subtotal]');

			if ( this.subtotal ) {
				this.subtotal.priceOriginal = this.subtotal.querySelector('[data-js-product-subtotal-price]');
				this.subtotal.priceCompare = this.subtotal.querySelector('[data-js-product-subtotal-compare]');
			}

			if ( this.quantityShortcuts ) {
				this.quantityShortcutsButtons = Array.from(this.quantityShortcuts.querySelectorAll('[data-quantity]'));
				this.quantityShortcutsButtons.forEach(btn => {
					btn.addEventListener('click', e => {
						e.preventDefault();
						this._setQuantity(parseInt(btn.dataset.quantity) || 1);
					});
				});
			}

			if ( this.qtyInput ) {
				this.qtyInput.addEventListener('change', this.updateQuantitySummary.bind(this));
				this.qtyInput.addEventListener('input', this.updateQuantitySummary.bind(this));
				this.updateQuantitySummary();
			}

		}

		_setQuantity(qty){

			const min = parseInt(this.qtyInput.getAttribute('min')) || 1,
						max = parseInt(this.qtyInput.getAttribute('max')) || 999;

			qty = Math.min(Math.max(qty, min), max);
			this.qtyInput.value = qty;

			const qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus');

			if ( qtyMinus ) qtyMinus.classList.toggle('disabled', qty - 1 < min);
			if ( qtyPlus ) qtyPlus.classList.toggle('disabled', qty + 1 > max);

			this.updateQuantitySummary();

		}

		updateQuantitySummary(){

			if ( ! this.qtyInput ) return;

			const qty = Math.max(parseInt(this.qtyInput.value) || 1, 1);
			let discountPercent = 0;

			if ( this.quantityShortcuts ) {

				const saveTemplate = this.quantityShortcuts.dataset.saveTemplate || '',
							basePrice = this.subtotal ? parseInt(this.subtotal.dataset.basePrice) || 0 : 0;

				// the applicable tier is the highest quantity threshold the current qty meets or exceeds
				let activeBtnQty = null;
				this.quantityShortcutsButtons.forEach(btn => {
					const btnQty = parseInt(btn.dataset.quantity) || 0;
					if ( btnQty <= qty && ( activeBtnQty === null || btnQty > activeBtnQty ) ) {
						activeBtnQty = btnQty;
					}
				});

				this.quantityShortcutsButtons.forEach(btn => {

					const btnQty = parseInt(btn.dataset.quantity) || 0,
								btnDiscount = parseInt(btn.dataset.discountPercent) || 0,
								btnUnit = btn.dataset.unit || '';

					btn.classList.toggle('is-active', btnQty === qty);
					if ( btnQty === activeBtnQty ) discountPercent = btnDiscount;

					const priceElm = btn.querySelector('[data-js-quantity-shortcuts-price]'),
								saveElm = btn.querySelector('[data-js-quantity-shortcuts-save]');

					if ( basePrice && priceElm ) {
						const discountCents = Math.floor(basePrice * btnDiscount / 100),
									unitPrice = basePrice - discountCents;
						priceElm.innerHTML = this._formatMoney(unitPrice, KROWN.settings.shop_money_format) + ( btnUnit ? '/' + btnUnit : '' );
						if ( saveElm ) {
							if ( btnDiscount > 0 ) {
								const saveCents = discountCents * btnQty;
								saveElm.innerHTML = saveTemplate.replace('__AMOUNT__', this._formatMoney(saveCents, KROWN.settings.shop_money_format));
								saveElm.style.display = '';
							} else {
								saveElm.innerHTML = '';
								saveElm.style.display = 'none';
							}
						}
					}

				});

			}

			if ( this.quantityShortcuts && ( this.priceCompact || this.priceExtended ) ) {

				const basePrice = parseInt(this.quantityShortcuts.dataset.basePrice) || 0,
							compareAtPrice = parseInt(this.quantityShortcuts.dataset.compareAtPrice) || 0,
							discountCents = Math.floor(basePrice * discountPercent / 100),
							unitPrice = basePrice - discountCents,
							effectiveComparePrice = discountPercent > 0 ? basePrice : compareAtPrice;

				this._updatePriceBlock(this.priceCompact, unitPrice, effectiveComparePrice);
				this._updatePriceBlock(this.priceExtended, unitPrice, effectiveComparePrice);

			}

			if ( this.subtotal && this.subtotal.priceOriginal ) {

				const basePrice = parseInt(this.subtotal.dataset.basePrice) || 0,
							originalTotal = basePrice * qty,
							discountCentsPerUnit = Math.floor(basePrice * discountPercent / 100),
							discountedTotal = originalTotal - (discountCentsPerUnit * qty);

				this.subtotal.priceOriginal.innerHTML = this._formatMoney(discountedTotal, KROWN.settings.shop_money_format);

				if ( this.subtotal.priceCompare ) {
					if ( discountedTotal < originalTotal ) {
						this.subtotal.priceCompare.innerHTML = this._formatMoney(originalTotal, KROWN.settings.shop_money_format);
						this.subtotal.priceCompare.style.display = '';
					} else {
						this.subtotal.priceCompare.innerHTML = '';
						this.subtotal.priceCompare.style.display = 'none';
					}
				}

			}

		}

		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || '${{amount}}';

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

		_updatePriceBlock(priceBlock, price, comparePrice){

			if ( ! priceBlock ) return;

			priceBlock.priceOriginal.innerHTML = this._formatMoney(price, KROWN.settings.shop_money_format);

			if ( comparePrice > price ) {

				if ( ! priceBlock.priceCompare ) {
					priceBlock.priceCompare = document.createElement('del');
					priceBlock.priceCompare.className = 'product-price--compare';
					priceBlock.priceCompare.setAttribute('data-js-product-price-compare', '');
					priceBlock.priceOriginal.insertAdjacentElement('afterend', priceBlock.priceCompare);
				}

				if ( priceBlock === this.priceExtended ) {
					priceBlock.priceCompare.innerHTML = `<span>${this._formatMoney(comparePrice, KROWN.settings.shop_money_format)}</span><span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this._formatMoney(comparePrice - price, KROWN.settings.shop_money_format))}</span>`;
				} else {
					priceBlock.priceCompare.innerHTML = this._formatMoney(comparePrice, KROWN.settings.shop_money_format);
				}

			} else if ( priceBlock.priceCompare ) {
				priceBlock.priceCompare.remove();
				priceBlock.priceCompare = null;
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'block';
					this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'block';
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			} else {

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'none';
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'none';
				}

			}

			// update prices (overwrites the framework)

			if ( this.priceCompact ) {
				if ( !variant ) {
					this.priceCompact.priceOriginal.innerHTML = '';
					if ( this.priceCompact.priceCompare ) {
						this.priceCompact.priceCompare.remove();
						this.priceCompact.priceCompare = null;
					}
					this.priceCompact.priceUnit.innerHTML = '';
				} else {
					this._updatePriceBlock(this.priceCompact, variant.price, variant.compare_at_price);

					if ( variant.unit_price_measurement ) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} /
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceCompact.priceUnit.innerHTML = '';
					}
				}
			}

			if ( this.priceExtended ) {
				if ( !variant ) {
					this.priceExtended.priceOriginal.innerHTML = '';
					if ( this.priceExtended.priceCompare ) {
						this.priceExtended.priceCompare.remove();
						this.priceExtended.priceCompare = null;
					}
					this.priceExtended.priceUnit.innerHTML = '';
				} else {
					this._updatePriceBlock(this.priceExtended, variant.price, variant.compare_at_price);

					if ( variant.unit_price_measurement ) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} /
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}

			// update quantity shortcuts + subtotal to reflect the new variant price

			if ( this.subtotal && variant ) {
				this.subtotal.dataset.basePrice = variant.price;
			}
			if ( this.quantityShortcuts && variant ) {
				this.quantityShortcuts.dataset.basePrice = variant.price;
				this.quantityShortcuts.dataset.compareAtPrice = variant.compare_at_price || 0;
			}
			this.updateQuantitySummary();

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}